export default function logError(error) {
  console.error(error);
}
